import { useRecrawlAccess } from '@components/SitemapReport/hooks'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import {
  ArrowDownToLine,
  Calendar,
  Refresh,
  Share,
} from '@octopus-do/octopus-storybook/icons'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { PLAN_FREE } from '@/constants/userSubscriptionPlans'
import { DownloadMenu } from '../../../DownloadMenu'

// The narrow-screen twin of the header's buttons, and it obeys the same rule:
// a reader who cannot change the report is offered the download alone.
export const SettingsMenuContent: React.FC = () => {
  const ownerPlan = useSelector(migrationProjectSelector.getProjectOwnerPlan)
  const { allowed } = useRecrawlAccess()

  const freeOwner = ownerPlan === PLAN_FREE

  return (
    <>
      {allowed && (
        <>
          <DropdownMenu.Button icon={Refresh} id="refresh" title="Refresh" />
          {!freeOwner && (
            <DropdownMenu.Button
              icon={Calendar}
              id="schedule"
              title="Schedule"
            />
          )}
          {freeOwner && (
            <DropdownMenu.BadgedButton
              type="pro"
              icon={Calendar}
              id="upgrade"
              title="Schedule"
            />
          )}
          <DropdownMenu.Divider />
          <DropdownMenu.Button icon={Share} id="share" title="Share" />
        </>
      )}
      <DropdownMenu.NestedMenu
        id="download"
        title="Download"
        icon={ArrowDownToLine}
        content={DownloadMenu}
      />
    </>
  )
}
